var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22048 0.900489C7.22075 0.900219 7.22075 0.899782 7.22048 0.899512L6.58458 0.263604C6.23311 -0.0878677 5.66326 -0.0878682 5.31179 0.263604L0.263585 5.3118C-0.0878871 5.66328 -0.0878869 6.23312 0.263585 6.5846C0.615057 6.93607 1.18491 6.93607 1.53638 6.5846L5.2401 2.88088C5.63062 2.49035 6.26379 2.49035 6.65431 2.88088L10.3566 6.58313C10.708 6.9346 11.2779 6.9346 11.6294 6.58313C11.9808 6.23166 11.9808 5.66181 11.6294 5.31034L7.22048 0.901465C7.22021 0.901195 7.22022 0.900758 7.22048 0.900489Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22116 8.85752C7.22143 8.85725 7.22143 8.85681 7.22116 8.85654L6.58526 8.22064C6.23378 7.86916 5.66394 7.86916 5.31246 8.22063L0.264264 13.2688C-0.0872081 13.6203 -0.0872079 14.1902 0.264264 14.5416C0.615736 14.8931 1.18558 14.8931 1.53706 14.5416L5.24078 10.8379C5.6313 10.4474 6.26447 10.4474 6.65499 10.8379L10.3572 14.5402C10.7087 14.8916 11.2786 14.8916 11.63 14.5402C11.9815 14.1887 11.9815 13.6188 11.63 13.2674L7.22116 8.8585C7.22089 8.85823 7.22089 8.85779 7.22116 8.85752Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingArrows);
export default __webpack_public_path__ + "static/media/upcomingArrows.975a5967b87252b96cc3c34dec3b1b35.svg";
export { ForwardRef as ReactComponent };